/** How a selected panel's check indicator is drawn. */
export enum SelectionPanelCheckStyle {
    /** Filled indicator with a white check mark (the default). */
    Checkmark = 'checkmark',
    /** Radio-style: the outline stays, with a filled dot (or square) inside it and no check mark. */
    Fill = 'fill',
}
